import React from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../authconfig';
import './LoginPage.css';

const floatingCerts = [
  { text: 'CompTIA',   top: '8%',    left: '4%',    rotate: '-12deg', size: '0.62rem' },
  { text: 'CISSP',     top: '14%',   right: '7%',   rotate: '5deg',   size: '0.68rem' },
  { text: 'AWS',       top: '44%',   left: '2.5%',  rotate: '-3deg',  size: '0.88rem' },
  { text: 'CCNA',      bottom: '23%',left: '5%',    rotate: '-8deg',  size: '0.64rem' },
  { text: 'Azure',     top: '31%',   right: '4%',   rotate: '7deg',   size: '0.7rem'  },
  { text: 'Security+', bottom: '16%',right: '5%',   rotate: '9deg',   size: '0.58rem' },
  { text: 'Network+',  top: '63%',   left: '3%',    rotate: '-5deg',  size: '0.6rem'  },
  { text: 'PMP',       top: '9%',    left: '38%',   rotate: '0deg',   size: '0.55rem' },
  { text: 'CEH',       bottom: '33%',right: '6%',   rotate: '-4deg',  size: '0.65rem' },
  { text: 'VMware',    bottom: '9%', left: '17%',   rotate: '5deg',   size: '0.6rem'  },
  { text: 'GCP',       top: '74%',   right: '11%',  rotate: '0deg',   size: '0.7rem'  },
  { text: 'PCEP',      top: '6%',    right: '27%',  rotate: '-7deg',  size: '0.57rem' },
];

const features = [
  { label: 'AI-generated questions', delay: '0.37s' },
  { label: 'Progress tracking',      delay: '0.44s' },
  { label: 'Hands-on lab guides',    delay: '0.51s' },
];

const Login = () => {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch((error) => {
      // AADB2C90118 = user clicked "Forgot Password".
      // With SSPR enabled on B2C_1_sus1 this should be handled inline by B2C
      // and never reach here. Log it if it somehow still fires.
      if (error.errorMessage && error.errorMessage.includes('AADB2C90118')) {
        console.warn('Forgot-password flow returned AADB2C90118 — ensure SSPR is saved in the B2C user flow.');
      } else if (error.errorCode !== 'user_cancelled') {
        console.error('Login failed:', error);
      }
    });
  };

  return (
    <div className="lp-root">

      {/* Background layers */}
      <div className="lp-bg-grid" />
      <div className="lp-bg-glow" />
      <div className="lp-bg-words" aria-hidden="true">
        {floatingCerts.map((c) => (
          <span
            key={c.text}
            className="lp-bg-word"
            style={{
              top: c.top,
              bottom: c.bottom,
              left: c.left,
              right: c.right,
              transform: `rotate(${c.rotate})`,
              fontSize: c.size,
            }}
          >
            {c.text}
          </span>
        ))}
      </div>

      {/* Main content */}
      <main className="lp-panel">

        {/* Hexagon icon mark */}
        <div className="lp-mark" aria-hidden="true">
          <svg className="lp-mark-svg" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M20 3L35 11.5V28.5L20 37L5 28.5V11.5L20 3Z"
              stroke="#f97316"
              strokeWidth="1.5"
              fill="rgba(249,115,22,0.07)"
            />
            <path
              d="M20 10L28 14.5V23.5L20 28L12 23.5V14.5L20 10Z"
              fill="rgba(249,115,22,0.14)"
              stroke="#f97316"
              strokeWidth="1"
            />
            <circle cx="20" cy="20" r="2.5" fill="#f97316" />
          </svg>
        </div>

        {/* Wordmark */}
        <h1 className="lp-wordmark">
          <span className="lp-w-smart">Smart</span><span className="lp-w-study">Study</span>
        </h1>

        {/* Tagline */}
        <p className="lp-tagline">
          Master every certification.<br />
          <span className="lp-tagline-em">On your own terms.</span>
        </p>

        {/* Divider */}
        <div className="lp-divider-line" />

        {/* Feature pills */}
        <div className="lp-features">
          {features.map(({ label, delay }) => (
            <span key={label} className="lp-feature" style={{ animationDelay: delay }}>
              <span className="lp-feature-dot" />
              {label}
            </span>
          ))}
        </div>

        {/* CTA */}
        <button className="lp-btn" onClick={handleLogin}>
          <span>Sign In / Sign Up</span>
          <span className="lp-btn-arrow" aria-hidden="true">→</span>
        </button>

        {/* Footer */}
        <p className="lp-note">Free to start · No credit card required</p>


      </main>
    </div>
  );
};

export default Login;
